import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const StarredDocsIcon = (props) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.00065 1.66699H10.9773C11.419 1.66699 11.8432 1.84283 12.1557 2.15533L16.179 6.17866C16.4915 6.49116 16.6673 6.91533 16.6673 7.35699V16.667C16.6673 17.5837 15.9173 18.3337 15.0007 18.3337H5.00065C4.08398 18.3337 3.33398 17.5837 3.33398 16.667V3.33366C3.33398 2.41699 4.08398 1.66699 5.00065 1.66699ZM10.834 7.50033H15.4173L10.834 2.91699V7.50033ZM11.6561 15.0303L9.99979 14.0306L8.34346 15.0303C8.08213 15.188 7.75979 14.9536 7.82913 14.6566L8.26879 12.7723L6.80513 11.5043C6.57446 11.3046 6.69779 10.9256 7.00179 10.9L8.92846 10.7366L9.68213 8.9583C9.80113 8.67796 10.1985 8.67796 10.3175 8.9583L11.0711 10.7366L12.9978 10.9C13.3018 10.9256 13.4251 11.3046 13.1945 11.5043L11.7308 12.7723L12.1705 14.6566C12.2398 14.9536 11.9175 15.188 11.6561 15.0303Z"
      fill={props.sx?.color || '#9C9FA5'}
    />
  </SvgIcon>
);

StarredDocsIcon.propTypes = {
  sx: PropTypes.object,
};

export default StarredDocsIcon;
